'use strict';

import { APIResponse } from "../APITypes";
import { csrfHeaders } from '../csrf';

export default class WaitlistEndpoint {
    static async Create(waitlist: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/waitlist/create',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(waitlist)
                }
            );
        
        if(!response.ok) {
            throw new Error("Waitlist registration failed.");
        }
        return await response.json();
    }

    static async SearchByEvent(searchOptions: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/waitlist/search',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(searchOptions)
                }
            );
        
        if(!response.ok) {
            throw new Error("Waitlist search failed.");
        }
        return await response.json();
    }

    static async Register(waitlist: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/waitlist/register',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(waitlist)
                }
            );
        
        if(!response.ok) {
            throw new Error("Waitlist registration failed.");
        }
        return await response.json();
    }

    static async RegisterNext(course_event_id: number): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/waitlist/register-next',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({course_event_id: course_event_id})
                }
            );
        
        if(!response.ok) {
            throw new Error("Register next on waitlist failed.");
        }
        return await response.json();
    }
}